import React from 'react';
import { useProductStore } from '@elem/compPage/CES2025/ProductProvider';
import css from './index.module.scss';
import A from './components/A';
import FixTab from './components/FixTab';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';

const Page: React.FC = () => {
    const { pageStatus } = useProductStore();
    return (
        <section className={`CES-Page ${css.page}`}>
            <A />
            <FixTab />
            {pageStatus === 'statusA' && <B />}
            {pageStatus === 'statusA' && (
                <>
                    <C />
                    <D />
                </>
            )}
            {pageStatus === 'statusB' && (
                <>
                    <D />
                    <C />
                    <F />
                    <G />
                </>
            )}
            <E />
            {pageStatus === 'statusB' && <H />}
        </section>
    );
};

export default Page;
